import { render, staticRenderFns } from "./CnReceipt.vue?vue&type=template&id=1d2307de&scoped=true&"
import script from "./CnReceipt.vue?vue&type=script&lang=js&"
export * from "./CnReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2307de",
  null
  
)

export default component.exports